import { render, staticRenderFns } from "./Shelf.vue?vue&type=template&id=169189ce&scoped=true&"
import script from "./Shelf.vue?vue&type=script&lang=js&"
export * from "./Shelf.vue?vue&type=script&lang=js&"
import style0 from "./Shelf.vue?vue&type=style&index=0&id=169189ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169189ce",
  null
  
)

export default component.exports